// This file is auto-generated by @hey-api/openapi-ts

import { createClient, createConfig, type Options, formDataBodySerializer } from '@hey-api/client-fetch';
import type { CreateCmsAttachmentData, CreateCmsAttachmentError, CreateCmsAttachmentResponse, GetCmsAttachmentData, GetCmsAttachmentError, GetCmsAttachmentResponse, CreateAttachmentData, CreateAttachmentError, CreateAttachmentResponse, ListAttachmentsByDatasourceData, ListAttachmentsByDatasourceError, ListAttachmentsByDatasourceResponse, GetAttachmentUrlData, GetAttachmentUrlError, GetAttachmentUrlResponse, GetAttachmentByKeyData, GetAttachmentByKeyError, GetAttachmentByKeyResponse, GetDatasourcesError, GetDatasourcesResponse, GetDatasourceData, GetDatasourceError, GetDatasourceResponse, FieldBoundaryByLocationData, FieldBoundaryByLocationError, FieldBoundaryByLocationResponse, LowResBoundariesByBboxData, LowResBoundariesByBboxError, LowResBoundariesByBboxResponse, HighResBoundariesByDetectedIdData, HighResBoundariesByDetectedIdError, HighResBoundariesByDetectedIdResponse, GetFarmsData, GetFarmsError, GetFarmsResponse, CreateFarmData, CreateFarmError, CreateFarmResponse, GetAllFarmsData, GetAllFarmsError, GetAllFarmsResponse, GetFarmByIdData, GetFarmByIdError, GetFarmByIdResponse, UpdateFarmData, UpdateFarmError, UpdateFarmResponse, DeleteFarmData, DeleteFarmError, DeleteFarmResponse, InviteToFarmData, InviteToFarmError, InviteToFarmResponse, ExportFieldBoundariesData, ExportFieldBoundariesError, ExportFieldBoundariesResponse, GetAnnumsForFarmData, GetAnnumsForFarmError, GetAnnumsForFarmResponse, PublicizeFarmData, PublicizeFarmError, PublicizeFarmResponse, PrivatizeFarmData, PrivatizeFarmError, PrivatizeFarmResponse, GetFieldImageryData, GetFieldImageryError, GetFieldImageryResponse, ListFieldUnusableMaskImageryData, ListFieldUnusableMaskImageryError, ListFieldUnusableMaskImageryResponse, GetFieldUnusableMaskImageryData, GetFieldUnusableMaskImageryError, GetFieldUnusableMaskImageryResponse, ListFieldProductImageryData, ListFieldProductImageryError, ListFieldProductImageryResponse, GetFieldProductImageryData, GetFieldProductImageryError, GetFieldProductImageryResponse, GetFieldDeltaFromNormImageryData, GetFieldDeltaFromNormImageryError, GetFieldDeltaFromNormImageryResponse, ListFieldAnomaliesImageryData, ListFieldAnomaliesImageryError, ListFieldAnomaliesImageryResponse, GetFieldAnomaliesImageryData, GetFieldAnomaliesImageryError, GetFieldAnomaliesImageryResponse, ListFieldColorizedBundleImageryData, ListFieldColorizedBundleImageryError, ListFieldColorizedBundleImageryResponse, GetFieldColorizedBundleImageryData, GetFieldColorizedBundleImageryError, GetFieldColorizedBundleImageryResponse, GetFieldNormMapImageryData, GetFieldNormMapImageryError, GetFieldNormMapImageryResponse, GetFieldVarianceMapImageryData, GetFieldVarianceMapImageryError, GetFieldVarianceMapImageryResponse, GetFieldsByFarmData, GetFieldsByFarmError, GetFieldsByFarmResponse, CreateFieldData, CreateFieldError, CreateFieldResponse, GetFieldData, GetFieldError, GetFieldResponse, UpdateFieldData, UpdateFieldError, UpdateFieldResponse, DeleteFieldData, DeleteFieldError, DeleteFieldResponse, FindCurrentFieldBoundaryData, FindCurrentFieldBoundaryError, FindCurrentFieldBoundaryResponse, FindFieldBoundaryData, FindFieldBoundaryError, FindFieldBoundaryResponse, GetAnnumsForFieldData, GetAnnumsForFieldError, GetAnnumsForFieldResponse, GetCombinedLayersForSourceData, GetCombinedLayersForSourceError, GetCombinedLayersForSourceResponse, GetSingleLayerForSourceData, GetSingleLayerForSourceError, GetSingleLayerForSourceResponse, ListDatesForLayerData, ListDatesForLayerError, ListDatesForLayerResponse, GetSingleLayerForSourceWithDateData, GetSingleLayerForSourceWithDateError, GetSingleLayerForSourceWithDateResponse, ListAllLayersForSourceData, ListAllLayersForSourceError, ListAllLayersForSourceResponse, GetInternalAllFarmsData, GetInternalAllFarmsError, GetInternalAllFarmsResponse, CreateInternalFarmData, CreateInternalFarmError, CreateInternalFarmResponse, GetInternalAnnumsForAllFarmsError, GetInternalAnnumsForAllFarmsResponse, GetInternalFarmByIdData, GetInternalFarmByIdError, GetInternalFarmByIdResponse, UpdateInternalFarmData, UpdateInternalFarmError, UpdateInternalFarmResponse, UpdateInternalFarmRolesData, UpdateInternalFarmRolesError, UpdateInternalFarmRolesResponse, UpdateInternalFieldForFarmData, UpdateInternalFieldForFarmError, UpdateInternalFieldForFarmResponse, GetInternalUserByIdData, GetInternalUserByIdError, GetInternalUserByIdResponse, EditUserInternalData, EditUserInternalError, EditUserInternalResponse, ListSectionsData, ListSectionsError, ListSectionsResponse, ListPublishedSectionsData, ListPublishedSectionsError, ListPublishedSectionsResponse, CreateOrUpdateSectionData, CreateOrUpdateSectionError, CreateOrUpdateSectionResponse, PublishSectionsData, PublishSectionsError, PublishSectionsResponse, ListFarmSectionsData, ListFarmSectionsError, ListFarmSectionsResponse, ListFarmPublishedSectionsData, ListFarmPublishedSectionsError, ListFarmPublishedSectionsResponse, CreateOrUpdateFarmSectionData, CreateOrUpdateFarmSectionError, CreateOrUpdateFarmSectionResponse, PublishFarmSectionsData, PublishFarmSectionsError, PublishFarmSectionsResponse, RegisterData, RegisterError, RegisterResponse, GetOnboardingFarmError, GetOnboardingFarmResponse, UpdateOnboardingFarmData, UpdateOnboardingFarmError, UpdateOnboardingFarmResponse, GetOnboardingFieldsError, GetOnboardingFieldsResponse, CreateOnboardingFieldData, CreateOnboardingFieldError, CreateOnboardingFieldResponse, GetOnboardingFieldByIdData, GetOnboardingFieldByIdError, GetOnboardingFieldByIdResponse, UpdateOnboardingFieldData, UpdateOnboardingFieldError, UpdateOnboardingFieldResponse, DeleteOnboardingFieldData, DeleteOnboardingFieldError, DeleteOnboardingFieldResponse, FindCurrentOnboardingFieldBoundaryData, FindCurrentOnboardingFieldBoundaryError, FindCurrentOnboardingFieldBoundaryResponse, CreateOnboardingAttachmentData, CreateOnboardingAttachmentError, CreateOnboardingAttachmentResponse, OnboardingFieldBoundaryByLocationData, OnboardingFieldBoundaryByLocationError, OnboardingFieldBoundaryByLocationResponse, OnboardingLowResBoundariesByBboxData, OnboardingLowResBoundariesByBboxError, OnboardingLowResBoundariesByBboxResponse, OnboardingHighResBoundariesByDetectedIdData, OnboardingHighResBoundariesByDetectedIdError, OnboardingHighResBoundariesByDetectedIdResponse, ResendEmailVerificationError, ResendEmailVerificationResponse, GetPublishedSystemContentData, GetPublishedSystemContentError, GetPublishedSystemContentResponse, UpdateSystemContentData, UpdateSystemContentError, UpdateSystemContentResponse, GetDraftSystemContentData, GetDraftSystemContentError, GetDraftSystemContentResponse, PublishSystemContentData, PublishSystemContentError, PublishSystemContentResponse, GetTileData, GetTileError, GetTileResponse, RegisterWithoutFarmError, RegisterWithoutFarmResponse, GetAccessTokenError, GetAccessTokenResponse, GetUserByIdData, GetUserByIdError, GetUserByIdResponse, EditUserData, EditUserError, EditUserResponse, DeleteUserData, DeleteUserError, DeleteUserResponse, GetAllUsersData, GetAllUsersError, GetAllUsersResponse, CreateUserData, CreateUserError, CreateUserResponse, ChangeUserPasswordData, ChangeUserPasswordError, ChangeUserPasswordResponse, GetMyUserError, GetMyUserResponse } from './types.gen';

export const client = createClient(createConfig());

/**
 * Create Cms Attachment
 * Returns the relative url of the uploaded image.
 */
export const createCmsAttachment = <ThrowOnError extends boolean = false>(options: Options<CreateCmsAttachmentData, ThrowOnError>) => {
    return (options?.client ?? client).post<CreateCmsAttachmentResponse, CreateCmsAttachmentError, ThrowOnError>({
        ...options,
        ...formDataBodySerializer,
        headers: {
            'Content-Type': null,
            ...options?.headers
        },
        url: '/farms/{farm_id}/annum/{annum}/attachments/cms'
    });
};

/**
 * Get Cms Attachment
 */
export const getCmsAttachment = <ThrowOnError extends boolean = false>(options: Options<GetCmsAttachmentData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetCmsAttachmentResponse, GetCmsAttachmentError, ThrowOnError>({
        ...options,
        url: '/farms/{farm_id}/attachments/cms/{id}'
    });
};

/**
 * Create Attachment
 * [summary]
 * Create a new attachment for uploading.
 *
 * [description]
 * This endpoint is used to create a new attachment for uploading, for a
 * specified datasource and filename. The attachment A dictionary with two
 * elements: `url` and `fields`.
 *
 * - `url` is the URL to post to.
 * - `fields` is a dictionary filled with the form fields and respective values
 * to use when submitting the post.
 *
 * For example:
 * ```json
 * {
 * "url": "https://mybucket.s3.amazonaws.com",
 * "fields": {
 * "acl": "public-read",
 * "key": "mykey",
 * "signature": "mysignature",
 * "policy": "mybase64 encoded policy"
 * "x-amz-meta-vayda-account-id": "123",
 * "x-amz-meta-vayda-farm-id": "456",
 * "x-amz-meta-vayda-datasource": "elevation",
 * "x-amz-meta-vayda-datasource-group": "OTHER",
 * ...
 * }
 * }
 * ```
 */
export const createAttachment = <ThrowOnError extends boolean = false>(options: Options<CreateAttachmentData, ThrowOnError>) => {
    return (options?.client ?? client).post<CreateAttachmentResponse, CreateAttachmentError, ThrowOnError>({
        ...options,
        url: '/farms/{farm_id}/annum/{annum}/attachments/{datasource}/{filename}'
    });
};

/**
 * List Attachments By Datasource
 */
export const listAttachmentsByDatasource = <ThrowOnError extends boolean = false>(options: Options<ListAttachmentsByDatasourceData, ThrowOnError>) => {
    return (options?.client ?? client).get<ListAttachmentsByDatasourceResponse, ListAttachmentsByDatasourceError, ThrowOnError>({
        ...options,
        url: '/farms/{farm_id}/attachments/{datasource}'
    });
};

/**
 * Get Attachment Url
 * [summary]
 * Get a signed URL for downloading an attachment.
 *
 * [description]
 * This endpoint returns a URL valid for downloading the attachment for a short
 * period - so should be used only when the user is ready to download the
 * attachment.
 *
 * NOTE: It is not implemented as a redirect due to a CORS issue with redirects
 * across multiple origins. Since the webapp is hosted on a different origin
 * than this api (i.e. vayda.ag vs api.vayda.ag), the browser will set the
 * Origin header to 'null' after redirecting to a third origin
 * (in this case S3). The S3 bucket CORS configuration will not allow the
 * origin header to be null, which is appropriate for security reasons.
 *
 * See https://w3c.github.io/webappsec-cors-for-developers/
 * 'If a cross-origin resource redirects to another resource at a new origin,
 * the browser will set the value of the Origin header to null after
 * redirecting.'
 */
export const getAttachmentUrl = <ThrowOnError extends boolean = false>(options: Options<GetAttachmentUrlData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetAttachmentUrlResponse, GetAttachmentUrlError, ThrowOnError>({
        ...options,
        url: '/farms/{farm_id}/attachments/dl/{key}'
    });
};

/**
 * Get Attachment By Key
 */
export const getAttachmentByKey = <ThrowOnError extends boolean = false>(options: Options<GetAttachmentByKeyData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetAttachmentByKeyResponse, GetAttachmentByKeyError, ThrowOnError>({
        ...options,
        url: '/farms/{farm_id}/attachments/{key}'
    });
};

/**
 * Get Datasources
 */
export const getDatasources = <ThrowOnError extends boolean = false>(options?: Options<unknown, ThrowOnError>) => {
    return (options?.client ?? client).get<GetDatasourcesResponse, GetDatasourcesError, ThrowOnError>({
        ...options,
        url: '/datasources'
    });
};

/**
 * Get Datasource
 */
export const getDatasource = <ThrowOnError extends boolean = false>(options: Options<GetDatasourceData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetDatasourceResponse, GetDatasourceError, ThrowOnError>({
        ...options,
        url: '/datasources/{datasource}'
    });
};

/**
 * Field Boundary By Location
 * Get a high resolution boundary based on a lat/lng location.
 */
export const fieldBoundaryByLocation = <ThrowOnError extends boolean = false>(options: Options<FieldBoundaryByLocationData, ThrowOnError>) => {
    return (options?.client ?? client).get<FieldBoundaryByLocationResponse, FieldBoundaryByLocationError, ThrowOnError>({
        ...options,
        url: '/boundaries/location'
    });
};

/**
 * Low Res Boundaries By Bbox
 * Get low resolution detected field boundaries within a bounding box. To fetch
 * the high resolution version of a given field, use the detected boundary ID
 * with /boundaries/highres/{detected_id}.
 */
export const lowResBoundariesByBbox = <ThrowOnError extends boolean = false>(options: Options<LowResBoundariesByBboxData, ThrowOnError>) => {
    return (options?.client ?? client).get<LowResBoundariesByBboxResponse, LowResBoundariesByBboxError, ThrowOnError>({
        ...options,
        url: '/boundaries/bbox'
    });
};

/**
 * High Res Boundaries By Detected Id
 * Get high resolution detected field boundaries by detected ID. The detected
 * ID is the unique identifier from the detected boundaries by bbox result.
 */
export const highResBoundariesByDetectedId = <ThrowOnError extends boolean = false>(options: Options<HighResBoundariesByDetectedIdData, ThrowOnError>) => {
    return (options?.client ?? client).get<HighResBoundariesByDetectedIdResponse, HighResBoundariesByDetectedIdError, ThrowOnError>({
        ...options,
        url: '/boundaries/highres/{detected_id}'
    });
};

/**
 * Get Farms
 */
export const getFarms = <ThrowOnError extends boolean = false>(options?: Options<GetFarmsData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetFarmsResponse, GetFarmsError, ThrowOnError>({
        ...options,
        url: '/farms'
    });
};

/**
 * Create Farm
 */
export const createFarm = <ThrowOnError extends boolean = false>(options: Options<CreateFarmData, ThrowOnError>) => {
    return (options?.client ?? client).post<CreateFarmResponse, CreateFarmError, ThrowOnError>({
        ...options,
        url: '/farms'
    });
};

/**
 * @deprecated
 * Get All Farms
 * Deprecated: Use `/internal/farms` instead. Note that /farms will load
 * all the farms the user has an explicit role for.
 * TODO: Remove get_all_farms from farm service
 */
export const getAllFarms = <ThrowOnError extends boolean = false>(options?: Options<GetAllFarmsData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetAllFarmsResponse, GetAllFarmsError, ThrowOnError>({
        ...options,
        url: '/all_farms'
    });
};

/**
 * Get Farm By Id
 */
export const getFarmById = <ThrowOnError extends boolean = false>(options: Options<GetFarmByIdData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetFarmByIdResponse, GetFarmByIdError, ThrowOnError>({
        ...options,
        url: '/farms/{farm_id}'
    });
};

/**
 * Update Farm
 */
export const updateFarm = <ThrowOnError extends boolean = false>(options: Options<UpdateFarmData, ThrowOnError>) => {
    return (options?.client ?? client).put<UpdateFarmResponse, UpdateFarmError, ThrowOnError>({
        ...options,
        url: '/farms/{farm_id}'
    });
};

/**
 * Delete Farm
 */
export const deleteFarm = <ThrowOnError extends boolean = false>(options: Options<DeleteFarmData, ThrowOnError>) => {
    return (options?.client ?? client).delete<DeleteFarmResponse, DeleteFarmError, ThrowOnError>({
        ...options,
        url: '/farms/{farm_id}'
    });
};

/**
 * Invite To Farm
 */
export const inviteToFarm = <ThrowOnError extends boolean = false>(options: Options<InviteToFarmData, ThrowOnError>) => {
    return (options?.client ?? client).post<InviteToFarmResponse, InviteToFarmError, ThrowOnError>({
        ...options,
        url: '/farms/{farm_id}/invite'
    });
};

/**
 * Export Field Boundaries
 */
export const exportFieldBoundaries = <ThrowOnError extends boolean = false>(options: Options<ExportFieldBoundariesData, ThrowOnError>) => {
    return (options?.client ?? client).get<ExportFieldBoundariesResponse, ExportFieldBoundariesError, ThrowOnError>({
        ...options,
        url: '/farms/{farm_id}/annum/{annum}/boundaries/{format}'
    });
};

/**
 * Get Annums For Farm
 * Return the list of years for which the farm has field annum data.
 */
export const getAnnumsForFarm = <ThrowOnError extends boolean = false>(options: Options<GetAnnumsForFarmData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetAnnumsForFarmResponse, GetAnnumsForFarmError, ThrowOnError>({
        ...options,
        url: '/farms/{farm_id}/annums'
    });
};

/**
 * Publicize Farm
 * Make the farm public, if it isn't already.
 *
 * Public farms are accessible to all users, even those who do not have an
 * explicit role on the farm.
 */
export const publicizeFarm = <ThrowOnError extends boolean = false>(options: Options<PublicizeFarmData, ThrowOnError>) => {
    return (options?.client ?? client).put<PublicizeFarmResponse, PublicizeFarmError, ThrowOnError>({
        ...options,
        url: '/farms/{farm_id}/public'
    });
};

/**
 * Privatize Farm
 * Make the farm private, if it isn't already.
 *
 * Private farms are only accessible to users who have an explicit role on the
 * farm, or have app-wide permissions to access all farms (e.g. admins).
 */
export const privatizeFarm = <ThrowOnError extends boolean = false>(options: Options<PrivatizeFarmData, ThrowOnError>) => {
    return (options?.client ?? client).delete<PrivatizeFarmResponse, PrivatizeFarmError, ThrowOnError>({
        ...options,
        url: '/farms/{farm_id}/public'
    });
};

/**
 * Get Field Imagery
 * Return available imagery for a FieldAnnum.
 *
 * This endpoint returns the status of the imagery for a field and annum. It
 * will also include URLs to the available imagery products and colorized
 * bundles.
 *
 * Note that the returned URLs are not an indication that they represent any
 * available imagery. The URLs are generated based on the field and annum
 * provided. The actual availability of the imagery will depend on the
 * `status` field in the response.
 *
 * Args:
 *
 * request: The current request that triggered this endpoint.
 * field_annum: The field and annum to get imagery for.
 *
 * Returns:
 *
 * The status of the imagery for the field and annum, along with URLs to
 * the available imagery products and colorized bundles.
 */
export const getFieldImagery = <ThrowOnError extends boolean = false>(options: Options<GetFieldImageryData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetFieldImageryResponse, GetFieldImageryError, ThrowOnError>({
        ...options,
        url: '/farms/{farm_id}/annum/{annum}/fields/{field_id}/imagery/'
    });
};

/**
 * List Field Unusable Mask Imagery
 * List unusable masks for a field and annum.
 */
export const listFieldUnusableMaskImagery = <ThrowOnError extends boolean = false>(options: Options<ListFieldUnusableMaskImageryData, ThrowOnError>) => {
    return (options?.client ?? client).get<ListFieldUnusableMaskImageryResponse, ListFieldUnusableMaskImageryError, ThrowOnError>({
        ...options,
        url: '/farms/{farm_id}/annum/{annum}/fields/{field_id}/imagery/unusable-mask'
    });
};

/**
 * Get Field Unusable Mask Imagery
 * Get an unusable mask for a field, annum, and item ID.
 */
export const getFieldUnusableMaskImagery = <ThrowOnError extends boolean = false>(options: Options<GetFieldUnusableMaskImageryData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetFieldUnusableMaskImageryResponse, GetFieldUnusableMaskImageryError, ThrowOnError>({
        ...options,
        url: '/farms/{farm_id}/annum/{annum}/fields/{field_id}/imagery/unusable-mask/{item_id}'
    });
};

/**
 * List Field Product Imagery
 * List products for a field, annum, and product type.
 */
export const listFieldProductImagery = <ThrowOnError extends boolean = false>(options: Options<ListFieldProductImageryData, ThrowOnError>) => {
    return (options?.client ?? client).get<ListFieldProductImageryResponse, ListFieldProductImageryError, ThrowOnError>({
        ...options,
        url: '/farms/{farm_id}/annum/{annum}/fields/{field_id}/imagery/product/{product}'
    });
};

/**
 * Get Field Product Imagery
 * Get a product for a field, annum, and item ID.
 */
export const getFieldProductImagery = <ThrowOnError extends boolean = false>(options: Options<GetFieldProductImageryData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetFieldProductImageryResponse, GetFieldProductImageryError, ThrowOnError>({
        ...options,
        url: '/farms/{farm_id}/annum/{annum}/fields/{field_id}/imagery/product/{product}/{item_id}'
    });
};

/**
 * Get Field Delta From Norm Imagery
 * Get a delta from norm for a field, annum, and item.
 */
export const getFieldDeltaFromNormImagery = <ThrowOnError extends boolean = false>(options: Options<GetFieldDeltaFromNormImageryData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetFieldDeltaFromNormImageryResponse, GetFieldDeltaFromNormImageryError, ThrowOnError>({
        ...options,
        url: '/farms/{farm_id}/annum/{annum}/fields/{field_id}/imagery/delta-from-norm/{product}/{baseline}/{item_id}'
    });
};

/**
 * List Field Anomalies Imagery
 * List anomalies for a FieldAnnum, product, and confidence.
 */
export const listFieldAnomaliesImagery = <ThrowOnError extends boolean = false>(options: Options<ListFieldAnomaliesImageryData, ThrowOnError>) => {
    return (options?.client ?? client).get<ListFieldAnomaliesImageryResponse, ListFieldAnomaliesImageryError, ThrowOnError>({
        ...options,
        url: '/farms/{farm_id}/annum/{annum}/fields/{field_id}/imagery/anomalies/{product}/{confidence}'
    });
};

/**
 * Get Field Anomalies Imagery
 * Get anomalies for a field, annum,, confidence, and item ID.
 */
export const getFieldAnomaliesImagery = <ThrowOnError extends boolean = false>(options: Options<GetFieldAnomaliesImageryData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetFieldAnomaliesImageryResponse, GetFieldAnomaliesImageryError, ThrowOnError>({
        ...options,
        url: '/farms/{farm_id}/annum/{annum}/fields/{field_id}/imagery/anomalies/{product}/{confidence}/{item_id}'
    });
};

/**
 * List Field Colorized Bundle Imagery
 * List colorized imagery bundles for a field, product, and confidence.
 */
export const listFieldColorizedBundleImagery = <ThrowOnError extends boolean = false>(options: Options<ListFieldColorizedBundleImageryData, ThrowOnError>) => {
    return (options?.client ?? client).get<ListFieldColorizedBundleImageryResponse, ListFieldColorizedBundleImageryError, ThrowOnError>({
        ...options,
        url: '/farms/{farm_id}/annum/{annum}/fields/{field_id}/imagery/bundle/{product}/{confidence}'
    });
};

/**
 * Get Field Colorized Bundle Imagery
 * Return colorized imagery bundle for a field, product, and item.
 *
 * An imagery bundle represents a generated and colorized anomaly map for a
 * field at a specific date, based on the product type and confidence level. It
 * also includes colorized images for all the dependent layers used to
 * calculate the anomaly map, including the delta from norm, variance map, and
 * norm map.
 *
 * An imagery bundle represents the assets uploaded to JDOC, and as such can be
 * used to create equivalent imagery deliveries in the regen web app.
 */
export const getFieldColorizedBundleImagery = <ThrowOnError extends boolean = false>(options: Options<GetFieldColorizedBundleImageryData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetFieldColorizedBundleImageryResponse, GetFieldColorizedBundleImageryError, ThrowOnError>({
        ...options,
        url: '/farms/{farm_id}/annum/{annum}/fields/{field_id}/imagery/bundle/{product}/{confidence}/{item_id}'
    });
};

/**
 * Get Field Norm Map Imagery
 * Get a norm map for a field, annum, product, and period.
 */
export const getFieldNormMapImagery = <ThrowOnError extends boolean = false>(options: Options<GetFieldNormMapImageryData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetFieldNormMapImageryResponse, GetFieldNormMapImageryError, ThrowOnError>({
        ...options,
        url: '/farms/{farm_id}/annum/{annum}/fields/{field_id}/imagery/norm-map/{product}/{period}'
    });
};

/**
 * Get Field Variance Map Imagery
 * Get a variance map for a field, annum, product, and period.
 */
export const getFieldVarianceMapImagery = <ThrowOnError extends boolean = false>(options: Options<GetFieldVarianceMapImageryData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetFieldVarianceMapImageryResponse, GetFieldVarianceMapImageryError, ThrowOnError>({
        ...options,
        url: '/farms/{farm_id}/annum/{annum}/fields/{field_id}/imagery/variance-map/{product}/{period}'
    });
};

/**
 * Get Fields By Farm
 */
export const getFieldsByFarm = <ThrowOnError extends boolean = false>(options: Options<GetFieldsByFarmData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetFieldsByFarmResponse, GetFieldsByFarmError, ThrowOnError>({
        ...options,
        url: '/farms/{farm_id}/annum/{annum}/fields'
    });
};

/**
 * Create Field
 */
export const createField = <ThrowOnError extends boolean = false>(options: Options<CreateFieldData, ThrowOnError>) => {
    return (options?.client ?? client).post<CreateFieldResponse, CreateFieldError, ThrowOnError>({
        ...options,
        url: '/farms/{farm_id}/annum/{annum}/fields'
    });
};

/**
 * Get Field
 */
export const getField = <ThrowOnError extends boolean = false>(options: Options<GetFieldData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetFieldResponse, GetFieldError, ThrowOnError>({
        ...options,
        url: '/farms/{farm_id}/annum/{annum}/fields/{field_id}'
    });
};

/**
 * Update Field
 * When editing a field with an assumed implicit annum, an attempt is made to
 * update the whole farm to the specified annum when there is no field_annum
 * for the current annum. If this is not possible, throw an error.
 *
 * See the `RequestedFieldAnnum` dependency for more information.
 */
export const updateField = <ThrowOnError extends boolean = false>(options: Options<UpdateFieldData, ThrowOnError>) => {
    return (options?.client ?? client).put<UpdateFieldResponse, UpdateFieldError, ThrowOnError>({
        ...options,
        url: '/farms/{farm_id}/annum/{annum}/fields/{field_id}'
    });
};

/**
 * Delete Field
 */
export const deleteField = <ThrowOnError extends boolean = false>(options: Options<DeleteFieldData, ThrowOnError>) => {
    return (options?.client ?? client).delete<DeleteFieldResponse, DeleteFieldError, ThrowOnError>({
        ...options,
        url: '/farms/{farm_id}/annum/{annum}/fields/{field_id}'
    });
};

/**
 * Find Current Field Boundary
 */
export const findCurrentFieldBoundary = <ThrowOnError extends boolean = false>(options: Options<FindCurrentFieldBoundaryData, ThrowOnError>) => {
    return (options?.client ?? client).get<FindCurrentFieldBoundaryResponse, FindCurrentFieldBoundaryError, ThrowOnError>({
        ...options,
        url: '/farms/{farm_id}/annum/{annum}/fields/{field_id}/boundary'
    });
};

/**
 * Find Field Boundary
 */
export const findFieldBoundary = <ThrowOnError extends boolean = false>(options: Options<FindFieldBoundaryData, ThrowOnError>) => {
    return (options?.client ?? client).get<FindFieldBoundaryResponse, FindFieldBoundaryError, ThrowOnError>({
        ...options,
        url: '/farms/{farm_id}/annum/{annum}/fields/{field_id}/boundary/{boundary_id}'
    });
};

/**
 * Get Annums For Field
 * Return the list of years for which the field has annum data.
 */
export const getAnnumsForField = <ThrowOnError extends boolean = false>(options: Options<GetAnnumsForFieldData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetAnnumsForFieldResponse, GetAnnumsForFieldError, ThrowOnError>({
        ...options,
        url: '/farms/{farm_id}/fields/{field_id}/annums'
    });
};

/**
 * Get Combined Layers For Source
 * Get data for all layers for the given farm and annum.
 */
export const getCombinedLayersForSource = <ThrowOnError extends boolean = false>(options: Options<GetCombinedLayersForSourceData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetCombinedLayersForSourceResponse, GetCombinedLayersForSourceError, ThrowOnError>({
        ...options,
        url: '/geo/v2/farms/{farm_id}/annum/{annum}/layers/{source}'
    });
};

/**
 * Get Single Layer For Source
 * Get data for a specific layer for the given farm and annum.
 */
export const getSingleLayerForSource = <ThrowOnError extends boolean = false>(options: Options<GetSingleLayerForSourceData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetSingleLayerForSourceResponse, GetSingleLayerForSourceError, ThrowOnError>({
        ...options,
        url: '/geo/v2/farms/{farm_id}/annum/{annum}/layers/{source}/{layer}'
    });
};

/**
 * List Dates For Layer
 * Get a list of dates containing data for specific layer for the given farm and annum.
 */
export const listDatesForLayer = <ThrowOnError extends boolean = false>(options: Options<ListDatesForLayerData, ThrowOnError>) => {
    return (options?.client ?? client).get<ListDatesForLayerResponse, ListDatesForLayerError, ThrowOnError>({
        ...options,
        url: '/geo/v2/farms/{farm_id}/annum/{annum}/layers/{source}/{layer}/dates'
    });
};

/**
 * Get Single Layer For Source With Date
 * Get date-specific data for a specific layer for the given farm and annum.
 */
export const getSingleLayerForSourceWithDate = <ThrowOnError extends boolean = false>(options: Options<GetSingleLayerForSourceWithDateData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetSingleLayerForSourceWithDateResponse, GetSingleLayerForSourceWithDateError, ThrowOnError>({
        ...options,
        url: '/geo/v2/farms/{farm_id}/annum/{annum}/layers/{source}/{layer}/dates/{date}'
    });
};

/**
 * List All Layers For Source
 * Get a list of all possible layers for the given geosource.
 */
export const listAllLayersForSource = <ThrowOnError extends boolean = false>(options: Options<ListAllLayersForSourceData, ThrowOnError>) => {
    return (options?.client ?? client).get<ListAllLayersForSourceResponse, ListAllLayersForSourceError, ThrowOnError>({
        ...options,
        url: '/geo/v2/layers/{source}'
    });
};

/**
 * Get Internal All Farms
 */
export const getInternalAllFarms = <ThrowOnError extends boolean = false>(options?: Options<GetInternalAllFarmsData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetInternalAllFarmsResponse, GetInternalAllFarmsError, ThrowOnError>({
        ...options,
        url: '/internal/farms'
    });
};

/**
 * Create Internal Farm
 */
export const createInternalFarm = <ThrowOnError extends boolean = false>(options: Options<CreateInternalFarmData, ThrowOnError>) => {
    return (options?.client ?? client).post<CreateInternalFarmResponse, CreateInternalFarmError, ThrowOnError>({
        ...options,
        url: '/internal/farms'
    });
};

/**
 * Get Internal Annums For All Farms
 * Return the list of years for which all farms have field annum data.
 */
export const getInternalAnnumsForAllFarms = <ThrowOnError extends boolean = false>(options?: Options<unknown, ThrowOnError>) => {
    return (options?.client ?? client).get<GetInternalAnnumsForAllFarmsResponse, GetInternalAnnumsForAllFarmsError, ThrowOnError>({
        ...options,
        url: '/internal/farms/annums'
    });
};

/**
 * Get Internal Farm By Id
 */
export const getInternalFarmById = <ThrowOnError extends boolean = false>(options: Options<GetInternalFarmByIdData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetInternalFarmByIdResponse, GetInternalFarmByIdError, ThrowOnError>({
        ...options,
        url: '/internal/farms/{farm_id}'
    });
};

/**
 * Update Internal Farm
 */
export const updateInternalFarm = <ThrowOnError extends boolean = false>(options: Options<UpdateInternalFarmData, ThrowOnError>) => {
    return (options?.client ?? client).put<UpdateInternalFarmResponse, UpdateInternalFarmError, ThrowOnError>({
        ...options,
        url: '/internal/farms/{farm_id}'
    });
};

/**
 * Update Internal Farm Roles
 */
export const updateInternalFarmRoles = <ThrowOnError extends boolean = false>(options: Options<UpdateInternalFarmRolesData, ThrowOnError>) => {
    return (options?.client ?? client).put<UpdateInternalFarmRolesResponse, UpdateInternalFarmRolesError, ThrowOnError>({
        ...options,
        url: '/internal/farms/{farm_id}/roles'
    });
};

/**
 * Update Internal Field For Farm
 */
export const updateInternalFieldForFarm = <ThrowOnError extends boolean = false>(options: Options<UpdateInternalFieldForFarmData, ThrowOnError>) => {
    return (options?.client ?? client).put<UpdateInternalFieldForFarmResponse, UpdateInternalFieldForFarmError, ThrowOnError>({
        ...options,
        url: '/internal/farms/{farm_id}/annum/{annum}/fields/{field_id}'
    });
};

/**
 * Get Internal User By Id
 */
export const getInternalUserById = <ThrowOnError extends boolean = false>(options: Options<GetInternalUserByIdData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetInternalUserByIdResponse, GetInternalUserByIdError, ThrowOnError>({
        ...options,
        url: '/internal/users/{user_id}'
    });
};

/**
 * Edit User Internal
 */
export const editUserInternal = <ThrowOnError extends boolean = false>(options: Options<EditUserInternalData, ThrowOnError>) => {
    return (options?.client ?? client).put<EditUserInternalResponse, EditUserInternalError, ThrowOnError>({
        ...options,
        url: '/internal/users/{user_id}'
    });
};

/**
 * List Sections
 */
export const listSections = <ThrowOnError extends boolean = false>(options: Options<ListSectionsData, ThrowOnError>) => {
    return (options?.client ?? client).get<ListSectionsResponse, ListSectionsError, ThrowOnError>({
        ...options,
        url: '/farms/{farm_id}/annum/{annum}/fields/{field_id}/modules/{module_type}'
    });
};

/**
 * List Published Sections
 */
export const listPublishedSections = <ThrowOnError extends boolean = false>(options: Options<ListPublishedSectionsData, ThrowOnError>) => {
    return (options?.client ?? client).get<ListPublishedSectionsResponse, ListPublishedSectionsError, ThrowOnError>({
        ...options,
        url: '/farms/{farm_id}/annum/{annum}/fields/{field_id}/modules/{module_type}/published'
    });
};

/**
 * Create Or Update Section
 */
export const createOrUpdateSection = <ThrowOnError extends boolean = false>(options: Options<CreateOrUpdateSectionData, ThrowOnError>) => {
    return (options?.client ?? client).put<CreateOrUpdateSectionResponse, CreateOrUpdateSectionError, ThrowOnError>({
        ...options,
        url: '/farms/{farm_id}/annum/{annum}/fields/{field_id}/modules/{module_type}/section/{section_type}'
    });
};

/**
 * Publish Sections
 */
export const publishSections = <ThrowOnError extends boolean = false>(options: Options<PublishSectionsData, ThrowOnError>) => {
    return (options?.client ?? client).put<PublishSectionsResponse, PublishSectionsError, ThrowOnError>({
        ...options,
        url: '/farms/{farm_id}/annum/{annum}/fields/{field_id}/modules/{module_type}/publish'
    });
};

/**
 * List Farm Sections
 */
export const listFarmSections = <ThrowOnError extends boolean = false>(options: Options<ListFarmSectionsData, ThrowOnError>) => {
    return (options?.client ?? client).get<ListFarmSectionsResponse, ListFarmSectionsError, ThrowOnError>({
        ...options,
        url: '/farms/{farm_id}/annum/{annum}/modules/{module_type}'
    });
};

/**
 * List Farm Published Sections
 */
export const listFarmPublishedSections = <ThrowOnError extends boolean = false>(options: Options<ListFarmPublishedSectionsData, ThrowOnError>) => {
    return (options?.client ?? client).get<ListFarmPublishedSectionsResponse, ListFarmPublishedSectionsError, ThrowOnError>({
        ...options,
        url: '/farms/{farm_id}/annum/{annum}/modules/{module_type}/published'
    });
};

/**
 * Create Or Update Farm Section
 */
export const createOrUpdateFarmSection = <ThrowOnError extends boolean = false>(options: Options<CreateOrUpdateFarmSectionData, ThrowOnError>) => {
    return (options?.client ?? client).put<CreateOrUpdateFarmSectionResponse, CreateOrUpdateFarmSectionError, ThrowOnError>({
        ...options,
        url: '/farms/{farm_id}/annum/{annum}/modules/{module_type}/section/{section_type}'
    });
};

/**
 * Publish Farm Sections
 */
export const publishFarmSections = <ThrowOnError extends boolean = false>(options: Options<PublishFarmSectionsData, ThrowOnError>) => {
    return (options?.client ?? client).put<PublishFarmSectionsResponse, PublishFarmSectionsError, ThrowOnError>({
        ...options,
        url: '/farms/{farm_id}/annum/{annum}/modules/{module_type}/publish'
    });
};

/**
 * Register
 * Register a user with the given farm data. If the user already exists, then
 * the farm will be associated with the specified user's account.
 */
export const register = <ThrowOnError extends boolean = false>(options: Options<RegisterData, ThrowOnError>) => {
    return (options?.client ?? client).post<RegisterResponse, RegisterError, ThrowOnError>({
        ...options,
        url: '/onboarding/register'
    });
};

/**
 * Get Onboarding Farm
 */
export const getOnboardingFarm = <ThrowOnError extends boolean = false>(options?: Options<unknown, ThrowOnError>) => {
    return (options?.client ?? client).get<GetOnboardingFarmResponse, GetOnboardingFarmError, ThrowOnError>({
        ...options,
        url: '/onboarding/farm'
    });
};

/**
 * Update Onboarding Farm
 */
export const updateOnboardingFarm = <ThrowOnError extends boolean = false>(options: Options<UpdateOnboardingFarmData, ThrowOnError>) => {
    return (options?.client ?? client).put<UpdateOnboardingFarmResponse, UpdateOnboardingFarmError, ThrowOnError>({
        ...options,
        url: '/onboarding/farm'
    });
};

/**
 * Get Onboarding Fields
 */
export const getOnboardingFields = <ThrowOnError extends boolean = false>(options?: Options<unknown, ThrowOnError>) => {
    return (options?.client ?? client).get<GetOnboardingFieldsResponse, GetOnboardingFieldsError, ThrowOnError>({
        ...options,
        url: '/onboarding/farm/fields'
    });
};

/**
 * Create Onboarding Field
 */
export const createOnboardingField = <ThrowOnError extends boolean = false>(options: Options<CreateOnboardingFieldData, ThrowOnError>) => {
    return (options?.client ?? client).post<CreateOnboardingFieldResponse, CreateOnboardingFieldError, ThrowOnError>({
        ...options,
        url: '/onboarding/farm/fields'
    });
};

/**
 * Get Onboarding Field By Id
 */
export const getOnboardingFieldById = <ThrowOnError extends boolean = false>(options: Options<GetOnboardingFieldByIdData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetOnboardingFieldByIdResponse, GetOnboardingFieldByIdError, ThrowOnError>({
        ...options,
        url: '/onboarding/farm/fields/{field_id}'
    });
};

/**
 * Update Onboarding Field
 */
export const updateOnboardingField = <ThrowOnError extends boolean = false>(options: Options<UpdateOnboardingFieldData, ThrowOnError>) => {
    return (options?.client ?? client).put<UpdateOnboardingFieldResponse, UpdateOnboardingFieldError, ThrowOnError>({
        ...options,
        url: '/onboarding/farm/fields/{field_id}'
    });
};

/**
 * Delete Onboarding Field
 */
export const deleteOnboardingField = <ThrowOnError extends boolean = false>(options: Options<DeleteOnboardingFieldData, ThrowOnError>) => {
    return (options?.client ?? client).delete<DeleteOnboardingFieldResponse, DeleteOnboardingFieldError, ThrowOnError>({
        ...options,
        url: '/onboarding/farm/fields/{field_id}'
    });
};

/**
 * Find Current Onboarding Field Boundary
 */
export const findCurrentOnboardingFieldBoundary = <ThrowOnError extends boolean = false>(options: Options<FindCurrentOnboardingFieldBoundaryData, ThrowOnError>) => {
    return (options?.client ?? client).get<FindCurrentOnboardingFieldBoundaryResponse, FindCurrentOnboardingFieldBoundaryError, ThrowOnError>({
        ...options,
        url: '/onboarding/farm/fields/{field_id}/boundary'
    });
};

/**
 * Create Onboarding Attachment
 * See attachment_router.py for more information on how to use this endpoint.
 * The onboarding version is limited to the unverified user's onboarding farm
 * and only field boundaries may be uploaded.
 */
export const createOnboardingAttachment = <ThrowOnError extends boolean = false>(options: Options<CreateOnboardingAttachmentData, ThrowOnError>) => {
    return (options?.client ?? client).post<CreateOnboardingAttachmentResponse, CreateOnboardingAttachmentError, ThrowOnError>({
        ...options,
        url: '/onboarding/boundaries/{filename}'
    });
};

/**
 * Onboarding Field Boundary By Location
 * Get a high resolution boundary based on a lat/lng location.
 */
export const onboardingFieldBoundaryByLocation = <ThrowOnError extends boolean = false>(options: Options<OnboardingFieldBoundaryByLocationData, ThrowOnError>) => {
    return (options?.client ?? client).get<OnboardingFieldBoundaryByLocationResponse, OnboardingFieldBoundaryByLocationError, ThrowOnError>({
        ...options,
        url: '/onboarding/boundaries/location'
    });
};

/**
 * Onboarding Low Res Boundaries By Bbox
 * Get low resolution detected field boundaries within a bounding box. To fetch
 * the high resolution version of a given field, use the detected boundary ID
 * with /boundaries/highres/{detected_id}.
 */
export const onboardingLowResBoundariesByBbox = <ThrowOnError extends boolean = false>(options: Options<OnboardingLowResBoundariesByBboxData, ThrowOnError>) => {
    return (options?.client ?? client).get<OnboardingLowResBoundariesByBboxResponse, OnboardingLowResBoundariesByBboxError, ThrowOnError>({
        ...options,
        url: '/onboarding/boundaries/bbox'
    });
};

/**
 * Onboarding High Res Boundaries By Detected Id
 * Get high resolution detected field boundaries by detected ID. The detected
 * ID is the unique identifier from the detected boundaries by bbox result.
 */
export const onboardingHighResBoundariesByDetectedId = <ThrowOnError extends boolean = false>(options: Options<OnboardingHighResBoundariesByDetectedIdData, ThrowOnError>) => {
    return (options?.client ?? client).get<OnboardingHighResBoundariesByDetectedIdResponse, OnboardingHighResBoundariesByDetectedIdError, ThrowOnError>({
        ...options,
        url: '/onboarding/boundaries/highres/{detected_id}'
    });
};

/**
 * Resend Email Verification
 * Request a new email verification email from Auth0.
 * Requires the user's sub, which we retrieve from the access token.
 */
export const resendEmailVerification = <ThrowOnError extends boolean = false>(options?: Options<unknown, ThrowOnError>) => {
    return (options?.client ?? client).post<ResendEmailVerificationResponse, ResendEmailVerificationError, ThrowOnError>({
        ...options,
        url: '/onboarding/resend_email_verification'
    });
};

/**
 * Get Published System Content
 * Returns the latest published content for the given system content type.
 *
 * This call is cached as it is expensive and also published content is
 * unlikely to change often.
 *
 * This call also can return a 204 status code if there is no published
 * content because that is legitimate for system content.
 */
export const getPublishedSystemContent = <ThrowOnError extends boolean = false>(options: Options<GetPublishedSystemContentData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetPublishedSystemContentResponse, GetPublishedSystemContentError, ThrowOnError>({
        ...options,
        url: '/cms/v1/system/text/annum/{annum}/{content_id}'
    });
};

/**
 * Update System Content
 */
export const updateSystemContent = <ThrowOnError extends boolean = false>(options: Options<UpdateSystemContentData, ThrowOnError>) => {
    return (options?.client ?? client).put<UpdateSystemContentResponse, UpdateSystemContentError, ThrowOnError>({
        ...options,
        url: '/cms/v1/system/text/annum/{annum}/{content_id}'
    });
};

/**
 * Get Draft System Content
 * Returns the latest document (draft or published) for the given system
 * content type. Fetching draft content requires update permissions
 * (since only those editing system content should be able to see drafts).
 */
export const getDraftSystemContent = <ThrowOnError extends boolean = false>(options: Options<GetDraftSystemContentData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetDraftSystemContentResponse, GetDraftSystemContentError, ThrowOnError>({
        ...options,
        url: '/cms/v1/system/text/annum/{annum}/{content_id}/draft'
    });
};

/**
 * Publish System Content
 */
export const publishSystemContent = <ThrowOnError extends boolean = false>(options: Options<PublishSystemContentData, ThrowOnError>) => {
    return (options?.client ?? client).put<PublishSystemContentResponse, PublishSystemContentError, ThrowOnError>({
        ...options,
        url: '/cms/v1/system/text/annum/{annum}/{content_id}/publish'
    });
};

/**
 * Get Tile
 */
export const getTile = <ThrowOnError extends boolean = false>(options: Options<GetTileData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetTileResponse, GetTileError, ThrowOnError>({
        ...options,
        url: '/v1/farms/{farm_id}/annum/{annum}/tiles/{source}/{tileset_type}/{period}/{timestamp}/{z}/{x}/{y}.{tileset_format}'
    });
};

/**
 * Register Without Farm
 * Register a user with the given auth token.
 */
export const registerWithoutFarm = <ThrowOnError extends boolean = false>(options?: Options<unknown, ThrowOnError>) => {
    return (options?.client ?? client).post<RegisterWithoutFarmResponse, RegisterWithoutFarmError, ThrowOnError>({
        ...options,
        url: '/users/register'
    });
};

/**
 * Get Access Token
 * Get the access token for the current user.
 */
export const getAccessToken = <ThrowOnError extends boolean = false>(options?: Options<unknown, ThrowOnError>) => {
    return (options?.client ?? client).get<GetAccessTokenResponse, GetAccessTokenError, ThrowOnError>({
        ...options,
        url: '/users/token'
    });
};

/**
 * Get User By Id
 */
export const getUserById = <ThrowOnError extends boolean = false>(options: Options<GetUserByIdData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetUserByIdResponse, GetUserByIdError, ThrowOnError>({
        ...options,
        url: '/users/{user_id}'
    });
};

/**
 * Edit User
 */
export const editUser = <ThrowOnError extends boolean = false>(options: Options<EditUserData, ThrowOnError>) => {
    return (options?.client ?? client).put<EditUserResponse, EditUserError, ThrowOnError>({
        ...options,
        url: '/users/{user_id}'
    });
};

/**
 * Delete User
 */
export const deleteUser = <ThrowOnError extends boolean = false>(options: Options<DeleteUserData, ThrowOnError>) => {
    return (options?.client ?? client).delete<DeleteUserResponse, DeleteUserError, ThrowOnError>({
        ...options,
        url: '/users/{user_id}'
    });
};

/**
 * Get All Users
 */
export const getAllUsers = <ThrowOnError extends boolean = false>(options?: Options<GetAllUsersData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetAllUsersResponse, GetAllUsersError, ThrowOnError>({
        ...options,
        url: '/users'
    });
};

/**
 * Create User
 */
export const createUser = <ThrowOnError extends boolean = false>(options: Options<CreateUserData, ThrowOnError>) => {
    return (options?.client ?? client).post<CreateUserResponse, CreateUserError, ThrowOnError>({
        ...options,
        url: '/users'
    });
};

/**
 * Change User Password
 */
export const changeUserPassword = <ThrowOnError extends boolean = false>(options: Options<ChangeUserPasswordData, ThrowOnError>) => {
    return (options?.client ?? client).post<ChangeUserPasswordResponse, ChangeUserPasswordError, ThrowOnError>({
        ...options,
        url: '/users/{user_id}/password_change'
    });
};

/**
 * Get My User
 * Note that the user's permissions will be empty until their email has been
 * verified.
 *
 * Every load of the regen-web app will call /my_user, so this is a very
 * reliable place to log information about a user's access.
 */
export const getMyUser = <ThrowOnError extends boolean = false>(options?: Options<unknown, ThrowOnError>) => {
    return (options?.client ?? client).get<GetMyUserResponse, GetMyUserError, ThrowOnError>({
        ...options,
        url: '/my_user'
    });
};